module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/15_6ba6dd417235e73b3b79e875dfdec681.jpg";